export * from "./existing-product-text";
